export * as dashboard from './dashboard'
export * as details from './details'
export * as stakeholderLog from './stakeholder-log'
export * as stakeholders from './stakeholders'
